/* eslint-disable no-unused-vars */

export const PATH = {
  AUTHORIZE: "/authorize",
  AUTHORIZE_CALLBACK: "/authorize/callback",
  AUTHORIZE_TOKEN_EXCHANGE: "/authorize/token-exchange",
  AUTHORIZE_LINE_CALLBACK: "/authorize/line-callback",

  UNLINK: "/unlink",
  UNLINK_CALLBACK: "/unlink/callback",

  MAPPING_SUCCESS: "/mapping-success",
  MAPPING_FAIL: "/mapping-fail",
  MAPPING_IS_NOT_AVAILABLE: "/mapping-is-not-available",
  MAPPING_ALREADY_MAPPING: "/already-mapping",
  UNLINK_SUCCESS: "/unlink-success",
  UNLINK_FAIL: "/unlink-fail",
  UID_IS_NOT_AVAILABLE: "/uid-is-not-available",
  NO_CONSENT: "/no-consent",

  GRAB: "/grab",
  GRAB_MAPPING: "/grab/mapping",
};
